import { GetterTree } from 'vuex';
import { TrainerPayrollState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<TrainerPayrollState, RootState> = {
  ['getTrainerPayrolls']: (state) => state.trainerPayrolls,
  ['getTrainerPayrollsIsLoading']: (state) => state.trainerPayrolls?.isLoading,
  ['getTrainerPayrollsTotal']: (state) => state.trainerPayrolls?.total,
  ['getTrainerPayrollsSearchParams']: (state) =>
    state.trainerPayrolls?.searchParams,
};
